<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">一件代发列表</span>
      <router-link :to="{path:'/One/OneImport',query:{post_batch_no:post_batch_no}}" class="btn-scan ivu-btn ivu-btn-primary fr ml20">导入一件代发</router-link>
    </div>
    <div class="mt20 f26 pt20">
      <b class="pr20">{{post_batch_no}}</b>
      <b>发货单数：{{total_count}} 个</b>
    </div>
    <!-- <div class="tr mb10">
      <button class="ivu-btn ivu-btn-primary" @click="exportData">下载数据</button>
    </div> -->
    <div class="search-one" style="margin-top: 20px;">
      <div class="search-item">
        出库单号
        <Input class='ml10 mr20 w200' v-model="screen_data.out_bill_no" placeholder="请输入出库单号" />
        状态
        <Select v-model="screen_data.status" class='ml10 mr20 w200'>
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </div>
      <div class="search-item">
        收件人
        <Input class='ml10 mr20 w200' v-model="screen_data.s_user_name" placeholder="请输入收件人" />
        创建时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="search">搜索</button>
      </div>

    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal title="查看详情" v-model="show_detail" width="1200" height="600">
      <div class="overflow-h">
        <div class="fl f16">
          <p>代发商品信息</p>
          <Table class="mt10" width="500" border :columns="sku_columns" :data="detailInfo.sku_list"> </Table>
          <p class="mt30">选择发货方式 USPS</p>
          <Table class="mt10" width="500" border :columns="package_columns" :data="detailInfo.package_list"></Table>
        </div>
        <div class="fl ml30 f16 addr-box">
          <p class="pb10">收件地址</p>
          <p><span>Receiver:</span> {{detailInfo.s_user_name}} </p>
          <p><span>Address 1:</span> {{detailInfo.s_address1}} </p>
          <p><span>Address 2:</span> {{detailInfo.s_address2}} </p>
          <p><span>State:</span> {{detailInfo.s_state}} </p>
          <p><span>City:</span> {{detailInfo.s_city}} </p>
          <p><span>Zipcode:</span> {{detailInfo.s_postcode}} </p>
          <p><span>Phone:</span> {{detailInfo.s_user_phone}} </p>
        </div>
      </div>
      <div class="tc" slot="footer">
        <button class="ivu-btn ivu-btn-primary" @click="show_detail=false">关闭</button>
      </div>
    </Modal>

  </main>

</template>

<script>
  import Paging from '@/components/common/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        post_batch_no: '',
        total_count: '',
        show_detail: false,
        detailInfo: {},
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: 10,
          label: '待打印'
        }, {
          value: 20,
          label: '待打包'
        }, {
          value: 30,
          label: '待支付'
        }, {
          value: 40,
          label: '待出库'
        }, {
          value: '-10',
          label: '已取消'
        }],
        sku_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 240,
          tooltip: true,
        }, {
          title: '数量',
          key: 'total_count',
          tooltip: true,
        }],
        package_columns: [{
          title: '包裹号',
          key: 'package_no',
          width: 240,
          tooltip: true,
        }, {
          title: 'USPS单号',
          key: 'tracking_no',
          tooltip: true,
        }],
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
      }
    },
    methods: {
      getDetail(post_batch_detail_id) {
        this.$axios.get("/WarehousePost/detail?post_batch_detail_id=" + post_batch_detail_id).then(res => {
          if (res.success && res.data) {
            this.detailInfo = res.data
          }
        })
        this.show_detail = true
      },
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.start_date = e + ' 00:00:00'
        } else {
          this.screen_data.start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.end_date = e + ' 23:59:59'
        } else {
          this.screen_data.end_date = ''
        }
      },
      // 付款
      pay(out_bill_no) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付单号为' + out_bill_no + '的发货单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.$axios.post("/ClientBill/fee/pay/post?out_bill_no=" + out_bill_no).then(res => {
              if (res.success) {
                that.$Message.success('支付成功');
                that.getList()
              }
            })
          },
          onCancel: () => {

          }
        });
      },
      //取消出库单
      cancel(post_batch_detail_id, out_bill_no) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要取消单号为 ' + out_bill_no + ' 的发货单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.$axios.post("/WarehousePost/detail/cancel?post_batch_detail_id=" + post_batch_detail_id).then(
              res => {
                if (res.success) {
                  that.$Message.success('取消成功');
                  that.getList()
                }
              })
          },
          onCancel: () => {

          }
        });

      },

      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/WarehousePost/detail/list", {
          params: {
            ...this.screen_data,
            post_batch_no: this.post_batch_no
          }
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      exportData(out_bill_no) {
        this.$axios.get("/WarehouseOut/bill/detail/export/excel", {
          params: {
            out_bill_no: out_bill_no
          }
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '出库单号',
          key: 'out_bill_no',
          tooltip: true,
          minWidth: 170,
        }, {
          title: '收件人',
          key: 's_user_name',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '手机号',
          key: 's_user_phone',
          tooltip: true,
          minWidth: 160,
        }, {
          title: '总重量',
          key: 'post_weight',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '运费（$）',
          key: 'post_fee',
          minWidth: 120,
          tooltip: true
        }, {
          title: '状态',
          key: 'salePrice',
          minWidth: 80,
          render: (h, params) => {
            let status = params.row.status;
            let color = '';
            let txt = '';
            if (status == 10) { //待打印
              color = '#D9001B'
              txt = '待打印'
            } else if (status == 20) { // 待打包
              color = '#4acd40'
              txt = '待打包'
            } else if (status == 30) { //待支付
              color = '#FFB800'
              txt = '待支付'
            } else if (status == 40) { //待出库
              color = '#169BD5'
              txt = '待出库'
            } else if (status == 50) { //已出库
              color = '#00B212'
              txt = '已出库'
            } else if (status == '-10') { //已取消
              color = '#333'
              txt = '已取消'
            }
            return h('span', {
              style: {
                color: color
              },
            }, txt)
          }
        }, {
          title: '发货快递',
          key: 'post_type',
          minWidth: 120,
          tooltip: true,
          render: (h, params) => {
            let post_type = params.row.post_type;
            let txt = '-';
            if (post_type == 0) {
              txt = 'USPS'
            }
            if (post_type == 1) {
              txt = 'UPS'
            }
            return h('span', txt)
          }
        }, {
          title: '创建时间',
          key: 'create_date',
          minWidth: 180,
          tooltip: true
        }, {
          title: '操作',
          minWidth: 120,
          render: (h, params) => {
            let doms = [];
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da",
                'margin-right': '10px'
              },
              on: {
                click: () => {
                  // this.detailInfo = params.row;
                  this.getDetail(params.row.post_batch_detail_id)
                }
              }
            }, '查看详情'));
            if (params.row.status == 10) {
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da"
                },
                on: {
                  click: () => {
                    this.cancel(params.row.post_batch_detail_id, params.row.out_bill_no)
                  }
                }
              }, '取消'));
            }
            if (params.row.status == 30) {
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da"
                },
                on: {
                  click: () => {
                    this.pay(params.row.out_bill_no)
                  }
                }
              }, '付款'));
            }
            return h("div", doms);
          }
        }];
        return arr;
      },
      setPrintColumns() {
        let arr = [];
        arr = [{
          title: 'SKU',
          key: 'sku',
          tooltip: true,
          minWidth: 150,
        }, {
          title: '新SKU',
          key: 'new_sku',
          tooltip: true,
          minWidth: 150,
        }, {
          title: '所在包裹',
          key: 'in_bill_no',
          tooltip: true,
          minWidth: 150,
        }, {
          title: '数量',
          key: 'out_count',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '所在货架',
          key: 'shelf_code',
          tooltip: true,
          minWidth: 150,
        }];
        return arr;
      }
    },
    created() {
      // this.screen_data.warehouse_id = localStorage.getItem('warehouse_id')
      // this.screen_data.client_code = localStorage.getItem('client_code') || ''
      this.post_batch_no = this.$route.query.post_batch_no;
      this.total_count = this.$route.query.total_count || 0;
      // if (this.screen_data.warehouse_id) {
      //   this.getList();
      // } else {
      //   this.$Message.info('请选择仓库')
      // }
      this.init();
      this.getList();
    }
  }
</script>

<style scoped>
  .stock .w200 {
    width: 200px !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }

  .addr-box p {
    margin-bottom: 10px;
  }

  .addr-box p span {
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/yikuhuanbiao/one/list.vue